/** Dialog for editing some VJT properties. */

import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Input, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@material-ui/core";
import React, { ChangeEvent, useEffect, useState } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Cancel, Save } from "@material-ui/icons";
import { objectToFormData } from "../../../../web-services/utils/object-to-form-data";
import { IFelhasznalokezeloEditDialogProps } from "./props";

import "./felhasznalokezelo-edit-dialog.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function FelhasznalokezeloEditDialog(props: IFelhasznalokezeloEditDialogProps)
{
    const [errorMsg, setErrorMsg] = useState<string | undefined>();
    const [errorCategoryMsg, setErrorCategoryMessage] = useState<string | undefined>();
    const [isRequestSending, setIsRequestSending] = useState<boolean | undefined>();
    const [selectedRoles, setSelectedRoles] = useState(props.user?.roles);
    const [roles, setRoles] = useState(props.roleok);

    const [id, setId] = useState(props.user?.id);
    const [username, setUsername] = useState(props.user?.username);
    const [teljesnev, setTeljesnev] = useState(props.user?.name);

    useEffect(() =>
    {
        setId(props.user?.id);
        setUsername(props.user?.username);
        setTeljesnev(props.user?.name);
        setRoles(props.roleok);
        setSelectedRoles(props.user?.roles);
        setErrorMsg(undefined);
    }, [props.user]);

    useEffect(() =>
    {
        if (!isRequestSending) return;

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            try
            {

                await props.httpClient.post(
                    "user/post-user-data",
                    "",
                    objectToFormData({
                        id: id,
                        name: teljesnev,
                        roles: selectedRoles?.map((role) => role.name)
                    }),
                    15000
                );
                setIsRequestSending(false);
                props.onSaveSuccess();
            }
            catch (err: any)
            {
                setIsRequestSending(false);
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorMsg("Kérjük, próbálja újra a mentést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    }, [isRequestSending]);

    const renderAlert = (errorText: string | undefined, errorCategoryText: string | undefined) => (
        errorText
            ? (
                <Grid item xs={12}>
                    <Alert severity="error" className="vjt-edit-error">{errorCategoryText
                        ? <AlertTitle>{errorCategoryText}</AlertTitle> : undefined}{errorText}
                    </Alert>
                </Grid>
            )
            : undefined
    );

    const renderCircularProgress = () => (
        isRequestSending
            ? <Grid item xs={12}><div className="circular-progress-container"><CircularProgress size={24} /></div></Grid>
            : undefined
    );

    const renderDialogActions = () =>
    {
        let buttons = [
            <Button
                key={8}
                startIcon={<Cancel />}
                variant="contained"
                color="secondary"
                onClick={props.onClose}
            >
                {id ? "Mégsem" : "Bezárás"}
            </Button>
        ];
        buttons.push(
            <Button
                key={9}
                startIcon={<Save />}
                variant="contained"
                disabled={isRequestSending}
                color="primary"
                onClick={() => setIsRequestSending(true)}
                autoFocus
            >
                Mentés
            </Button>
        );

        return buttons;
    };


    const renderMegnevezesAndPortalIp = () =>
    {
        let megnevezesAndPortalIpFields = [];

        megnevezesAndPortalIpFields.push(
            <Grid item xs={12} key={10}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel>Felhasználónév</InputLabel>
                    <Input
                        disabled={id ? true : false}
                        value={username}
                    />
                </FormControl>
            </Grid>
        );

        megnevezesAndPortalIpFields.push(
            <Grid item xs={12} key={11}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel>Név</InputLabel>
                    <Input
                        value={teljesnev}
                        onChange={(event: ChangeEvent<{
                            name?: string | undefined;
                            value: unknown;
                        }>) => setTeljesnev(event.target.value as string)}
                    />
                </FormControl>
            </Grid>
        );
        megnevezesAndPortalIpFields.push(
            <Grid item xs={12} key={12}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel id="demo-mutiple-checkbox-label">Jogosultságok</InputLabel>
                    <Select
                        labelId="demo-mutiple-checkbox-label"
                        id="demo-mutiple-checkbox"
                        multiple
                        value={selectedRoles?.map(role => role.id)}
                        onChange={handleChange}
                        input={<Input />}
                        renderValue={(selected) =>
                        {
                            const selectedIds = selected as number[];
                            return selectedIds?.map((roleId) => roles.find((role) => role.id === roleId)?.name).join(", ");
                        }}

                    >
                        {roles.map((role, index) => (
                            <MenuItem key={index} value={role.id}>
                                <Checkbox checked={selectedRoles ? selectedRoles.some(selectedRole => selectedRole.id === role.id) : false} />
                                <ListItemText primary={role.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        );

        return megnevezesAndPortalIpFields;
    };
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) =>
    {
        const selectedRoleIds = event.target.value as number[];
        const selectedRoless = roles.filter(role => selectedRoleIds.includes(role.id));
        setSelectedRoles(selectedRoless);
    };


    return (
        <Dialog open={props.open || false}>
            <DialogTitle>Felhasználó módosítás</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {renderMegnevezesAndPortalIp()}
                    {renderCircularProgress()}
                    {renderAlert(errorMsg, errorCategoryMsg)}
                </Grid>
            </DialogContent>
            <DialogActions>
                {renderDialogActions()}
            </DialogActions>
        </Dialog>
    );
}
